import { Day } from "types/Setting";

export const DEFAULT_WORKING_TIME = { start: "09:00", end: "17:00" };

export const DAYS = Object.values(Day);

export const MAXIMUM_WORKING_HOURS = 3;
